"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const office_ui_fabric_react_1 = require("office-ui-fabric-react");
const logo_svg_1 = __importDefault(require("../../../logo.svg"));
const logoStyle = {
    maxWidth: '120px',
    marginLeft: '10px'
};
const verticalBarStyle = {
    width: '2px',
    backgroundColor: 'white',
    marginLeft: '20px',
    marginRight: '20px',
    opacity: 0.5
};
const navTitleStyle = {
    root: {
        color: 'white',
        fontWeight: office_ui_fabric_react_1.FontWeights.semibold
    }
};
const LogoTitle = () => react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("img", { src: logo_svg_1.default, alt: "logo", style: logoStyle }),
    react_1.default.createElement("div", { style: verticalBarStyle }),
    react_1.default.createElement(office_ui_fabric_react_1.Text, { variant: "large", styles: navTitleStyle }, "Harvester"));
exports.default = LogoTitle;
